

<template>
  <div class="carrieres w-full text-zinc-500">
    <div class="imgg">
      <div class="text-overlay w-full text-center text-white text-3xl font-extrabold">
        <h2>4 raisons de nous rejoindre</h2>
      </div>
      
    </div>

    <div class="w-full mx-auto mt-10">
      <div class="w-4/6 mx-auto text-center ">
       <p class="resume mt-4 mb-10">
        Rejoindre GTHCONSULT, c'est grandir au sein d'une entreprise résolument apprenante et collaborative. <br>
        L'expérience de nos inspecteurs est basée sur des formations technique fondées, la précision de nos outils et la qualité de nos prestations vous permettent de faire du contrôle avec une source de sécurité mais aussi de valeur ajoutée à nos clients.

      </p>
      <p class="resume w-5/6 mx-auto text-center border-4 border-y-white border-x-red-600">“ORGANISME GTHCONSULT,  c'est un magnifique dynamique de croissance et une entreprise en transformation : rejoindre GTHCONSULT, c'est partager une aventure collective passionnante, des métiers à forte valeur ajoutée dans une entreprise qui avance chaque jours”</p>

      </div>
    </div>
  
      <div class="w-full flex mt-24 ">
        
          <div class="w-1/2 mr-36">
            <div class=" flex justify-end">
              <div class="flex items-center" data-aos="fade-left">
                <p class="text-blue-500 mr-2 font-bold">VALEURS                </p>
                <div class="cercle  flex items-center justify-center  w-16 h-16 rounded-full bg-zinc-200 " >
                        <div class="cercle2 text-white flex items-center justify-center w-14 h-14 rounded-full bg-blue-500" >

                          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="50" fill="currentColor" class="bi bi-brightness-high" viewBox="0 0 16 16"> <path d="M8 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0 1a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"/> </svg>
                        </div>
              </div>
            </div>
              <div class=""><div id="chevron"></div></div>
            </div>
          </div>
        
        <div class="w-1/2">
          <div>
            <div class="w-2/6 text-xl border-b-4 pb-4 border-blue-500" data-aos="fade-right">
              <h1 class="w-8 flex items-center justify-center text-white h-8 bg-blue-500 rounded-full ">1</h1>
              Esprit équipe,
              Honnêteté,
              Professionnalisme,
              Indépendance,
              Transparence.
              </div>
            
          </div>
        </div>
      </div>


      <div class="w-full flex mt-2 ">
        
        <div class="w-1/2 mr-36">
          <div class=" flex justify-end">
            <div class="flex items-center" data-aos="fade-left">
              <p class="text-purple-900 mr-2 font-bold">PERSONNALITÉ  </p>
              <div class="cercle  flex items-center justify-center  w-16 h-16 rounded-full bg-zinc-200 " >
                      <div class="cercle2 text-white flex items-center justify-center w-14 h-14 rounded-full bg-purple-900" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-file-earmark-text" viewBox="0 0 16 16"> <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"/> <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/> </svg>
                      </div>
            </div>
          </div>
            <div class=""><div id="chevron2"></div></div>
          </div>
        </div>
      
      <div class="w-1/2">
        <div>
          <div class="w-2/6 text-xl border-b-4 pb-4 border-purple-900" data-aos="fade-right">
            <h1 class="w-8 flex items-center justify-center text-white h-8 bg-purple-900 rounded-full ">2</h1>
            Savoir-être,
            Engagement,
            Disponibilité,
            Motivation,
            Satisfaction client.
            
            </div>
          
        </div>
      </div>
    </div>




    <div class="w-full flex mt-2">
        
      <div class="w-1/2 mr-36">
        <div class=" flex justify-end">
          <div class="flex items-center " data-aos="fade-left">
            <p class="text-purple-600 mr-2 font-bold">COMPÉTENCE            </p>
            <div class="cercle  flex items-center justify-center  w-16 h-16 rounded-full bg-zinc-200 " data-aos="fade-left">
                    <div class="cercle2 text-white flex items-center justify-center w-14 h-14 rounded-full bg-purple-600">
                     <svg style="color: white" width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M18.5 26C18.5 28.21 16.71 30 14.5 30C12.29 30 10.5 28.21 10.5 26C10.5 23.79 12.29 22 14.5 22C16.71 22 18.5 23.79 18.5 26Z" fill="white"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 28C15.6054 28 16.5 27.1054 16.5 26C16.5 24.8946 15.6054 24 14.5 24C13.3946 24 12.5 24.8946 12.5 26C12.5 27.1054 13.3946 28 14.5 28ZM14.5 30C16.71 30 18.5 28.21 18.5 26C18.5 23.79 16.71 22 14.5 22C12.29 22 10.5 23.79 10.5 26C10.5 28.21 12.29 30 14.5 30Z" fill="white"></path> <path d="M6 36.5455C6 33.5227 11.6631 32 14.5 32C17.3369 32 23 33.5227 23 36.5455V42H6V36.5455Z" fill="white"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.3342 35.9834C8.01826 36.2952 8 36.4741 8 36.5455V40H21V36.5455C21 36.4741 20.9817 36.2952 20.6658 35.9834C20.3323 35.6542 19.7814 35.3011 19.0262 34.9776C17.5068 34.3266 15.65 34 14.5 34C13.35 34 11.4932 34.3266 9.97382 34.9776C9.21864 35.3011 8.66768 35.6542 8.3342 35.9834ZM14.5 32C11.6631 32 6 33.5227 6 36.5455V42H23V36.5455C23 33.5227 17.3369 32 14.5 32Z" fill="white"></path> <path d="M37.5 26C37.5 28.21 35.71 30 33.5 30C31.29 30 29.5 28.21 29.5 26C29.5 23.79 31.29 22 33.5 22C35.71 22 37.5 23.79 37.5 26Z" fill="white"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M33.5 28C34.6054 28 35.5 27.1054 35.5 26C35.5 24.8946 34.6054 24 33.5 24C32.3946 24 31.5 24.8946 31.5 26C31.5 27.1054 32.3946 28 33.5 28ZM33.5 30C35.71 30 37.5 28.21 37.5 26C37.5 23.79 35.71 22 33.5 22C31.29 22 29.5 23.79 29.5 26C29.5 28.21 31.29 30 33.5 30Z" fill="white"></path> <path d="M28 24C28 26.21 26.21 28 24 28C21.79 28 20 26.21 20 24C20 21.79 21.79 20 24 20C26.21 20 28 21.79 28 24Z" fill="white"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M24 26C25.1054 26 26 25.1054 26 24C26 22.8946 25.1054 22 24 22C22.8946 22 22 22.8946 22 24C22 25.1054 22.8946 26 24 26ZM24 28C26.21 28 28 26.21 28 24C28 21.79 26.21 20 24 20C21.79 20 20 21.79 20 24C20 26.21 21.79 28 24 28Z" fill="white"></path> <path d="M23 12.8333C23 10.164 20.836 8 18.1667 8H14.9983C12.2378 8 10 10.2378 10 12.9983C10 15.6881 12.1286 17.8956 14.8167 17.9933L15 18V20C15 20 23 18.8333 23 12.8333Z" fill="white"></path> <path d="M26 11.2361C26 8.34429 28.3443 6 31.2361 6H37C39.7614 6 42 8.23858 42 11C42 13.7614 39.7614 16 37 16H35V19C35 19 26 17.7361 26 11.2361Z" fill="white"></path> <path d="M25 36.5455C25 33.5227 30.6631 32 33.5 32C36.3369 32 42 33.5227 42 36.5455V42H25V36.5455Z" fill="white"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M27.3342 35.9834C27.0183 36.2952 27 36.4741 27 36.5455V40H40V36.5455C40 36.4741 39.9817 36.2952 39.6658 35.9834C39.3323 35.6542 38.7814 35.3011 38.0262 34.9776C36.5068 34.3266 34.65 34 33.5 34C32.35 34 30.4932 34.3266 28.9738 34.9776C28.2186 35.3011 27.6677 35.6542 27.3342 35.9834ZM33.5 32C30.6631 32 25 33.5227 25 36.5455V42H42V36.5455C42 33.5227 36.3369 32 33.5 32Z" fill="white"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M24.0001 35H24.0001V34.5455C24.0001 32.8677 22.1527 31.652 19.9951 30.9024C21.1034 30.3829 22.4568 30 24.0001 30C25.5434 30 26.8968 30.3829 28.0051 30.9024C25.8475 31.652 24.0001 32.8677 24.0001 34.5455V35Z" fill="white"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M24.0001 35V34.5455C24.0001 33.6516 24.5245 32.8889 25.3407 32.258C25.3868 32.2224 25.4337 32.1872 25.4816 32.1525C26.1778 31.6469 27.0618 31.2301 28.0051 30.9024C27.1523 30.5027 26.1545 30.1838 25.0367 30.058C24.7017 30.0204 24.3559 30 24.0001 30C23.6443 30 23.2985 30.0204 22.9635 30.058C21.8457 30.1838 20.8479 30.5027 19.9951 30.9024C20.9384 31.2301 21.8224 31.6469 22.5186 32.1525C22.5665 32.1872 22.6134 32.2224 22.6595 32.258C23.4757 32.8889 24.0001 33.6516 24.0001 34.5455V35H24.0001Z" fill="white"></path> </svg>
                    </div>
          </div>
        </div>
          <div class=""><div id="chevron3"></div></div>
        </div>
      </div>
    
    <div class="w-1/2">
      <div>
        <div class="w-2/6 text-xl border-b-4 pb-4 border-purple-600" data-aos="fade-right">
          <h1 class="w-8 flex items-center justify-center text-white h-8 bg-purple-600 rounded-full ">3</h1>
          Savoir-faire,
          Formations métiers,
          Matériels d'expertise
          </div>
        
      </div>
    </div>
  </div>

  <div class="w-full flex mt-2 ">
        
    <div class="w-1/2 mr-36">
      <div class=" flex justify-end">
        <div class="flex items-center" data-aos="fade-left">
          <p class="text-red-700 mr-2 font-bold">POTENTIEL</p>
          <div class="cercle  flex items-center justify-center  w-16 h-16 rounded-full bg-zinc-200 " >
                  <div class="cercle2 flex items-center justify-center w-14 h-14 rounded-full bg-red-700">
                    <svg style="color: white" xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16"> <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" fill="white"></path> </svg>
                  </div>
        </div>
      </div>
        <div class=""><div id="chevron4"></div>
       
      </div>
      </div>
    </div>
  
  <div class="w-1/2">
    <div>
      <div class="w-2/6 text-xl border-b-4 pb-4 border-red-700" data-aos="fade-right">
        <h1 class="w-8 flex items-center justify-center text-white h-8 bg-red-700 rounded-full ">4</h1>
        Travailler au sein d'une bonne ambiance.

Travailler en équipe et être autonome.

Travailler dans un cadre flexible.

Évoluer dans un cadre dynamique.

        </div>
      
    </div>
  </div>
</div>
   
    
    

    
  </div>
</template>

<script>

export default {
  name : "OffreEmploiView",
 

}
</script>

<style scoped>
*{
  font-family: Cairo,Verdana,Tahoma,Arial;
}


.titre {
    text-align: center;
    font-size: xx-large;
    font-weight: 700;
    font-size: 1.77777778rem;
    line-height: 120%;
    color: #00153C;
}
.resume {
    padding: 10px;
    font-family: Cairo,Verdana,Tahoma,Arial;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    color: #616161;
    text-align: justify;
}

.badget {
    margin-top: 20px;
    font-family: Cairo,Verdana,Tahoma,Arial;
    font-style: normal;
    font-weight: 200;
    font-size: 20px;
    line-height: 150%;
    letter-spacing: 0em;
    color: #616161;
}

.imgg {
  width: 100%;
  height: 500px;
  overflow:hidden;
  position: relative;
  background-image: url("https://gthpdf.fra1.digitaloceanspaces.com/Nous_rejoindre-min.jpg");
  background-size: 100%;
  background-repeat: no-repeat;
}

.text-overlay {
    padding: 5%;
    margin: auto;
    position: absolute;
    z-index: 999;
    text-align: center;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    background-color: rgb(1, 1, 1, 0.6);
}
.text-overlay > h2 {
  color : #56be25;
  font-size: 40px;
}

#chevron {
  position: relative;
  text-align: center;
  padding: 12px;
  margin-bottom: 6px;
  min-height: 180px;
  width: 80px;
}
#chevron:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 51%;
  background: rgb(62, 152, 242);
  transform: skew(0deg, 40deg);
}
#chevron:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  background: rgb(62, 152, 242);
  transform: skew(0deg, -40deg);
}




#chevron2 {
  position: relative;
  text-align: center;
  padding: 12px;
  margin-bottom: 6px;
  min-height: 180px;
  width: 80px;
}
#chevron2:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 51%;
  background: rgb(114, 3, 157);
  transform: skew(0deg, 40deg);
}
#chevron2:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  background: rgb(114, 3, 157);
  transform: skew(0deg, -40deg);
}




#chevron3 {
  position: relative;
  text-align: center;
  padding: 12px;
  margin-bottom: 6px;
  min-height: 150px;
  width: 80px;
}
#chevron3:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 51%;
  background: rgb(141, 2, 197);
  transform: skew(0deg, 40deg);
}
#chevron3:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  background: rgb(141, 2, 197);
  transform: skew(0deg, -40deg);
}



#chevron4 {
  content: '';
  position: relative;
  text-align: center;
  padding: 12px;
  margin-bottom: 6px;
  min-height: 200px;
  width: 80px;
}
#chevron4:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 51%;
  background: rgb(189, 38, 4);
  transform: skew(0deg, 40deg);
}
#chevron4:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  background: rgb(189, 38, 4);
  transform: skew(0deg, -40deg);
}
.cercle{
  margin-right: -15px;
  z-index: 99;
}



</style>